// extracted by mini-css-extract-plugin
export default {"collections_wrapper":"Collections_collections_wrapper__ID5PT","selection_cover_item":"Collections_selection_cover_item__WL8wV"};